const MEASUREMENT_ID = 'G-B8ZFHDXF2D';

export const loadGoogleAnalytics = () => {
  if (typeof window === 'undefined' || window.gaLoaded) return;
  window.gaLoaded = true;

  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', MEASUREMENT_ID);
};

export const clearGoogleAnalyticsCookies = () => {
  const cookiesToClear = ['_ga', `_ga_${MEASUREMENT_ID.replace('G-', '')}`];
  const domains = [window.location.hostname, `.${window.location.hostname}`];

  cookiesToClear.forEach((name) => {
    domains.forEach((domain) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain}`;
    });
  });
};
